import { setFormErrors as setNestedFormErrors } from './subform';

interface MutationErrorHandlerParams {
    response: any;
    setFieldErrors: (errors: Record<string, any>) => void;
    setError?: (error: string | null) => void;
    showError: (message: string) => void;
}

export const handleMutationError = ({
    response,
    setFieldErrors,
    setError,
    showError
}: MutationErrorHandlerParams): void => {
    if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
        const errorMessage = response.errors.join(', ');
        if (setError) setError(errorMessage);
        showError(errorMessage);
        return;
    }

    if (response.data?.errors || response.errors) {
        const errors = response.data?.errors || response.errors;

        const isValidationError = Object.keys(errors).some(key => isNaN(Number(key)));

        if (!isValidationError) {
            const errorMessage = response.data?.message || 'Chyba servera';
            if (setError) setError(errorMessage);
            showError(errorMessage);
            return;
        }

        const formattedErrors: Record<string, any> = {};
        setNestedFormErrors(errors, (field: string, message: string) => {
            formattedErrors[field] = message;
        });

        setFieldErrors(formattedErrors);
        if (setError) setError('Skontrolujte zadané údaje');
        showError('Skontrolujte zadané údaje');
        return;
    }

    const errorMessage = response.message || 'Chyba pri ukladaní';
    if (setError) setError(errorMessage);
    showError(errorMessage);
};

interface MutationSuccessHandlerParams {
    setFieldErrors: (errors: Record<string, any>) => void;
    setError?: (error: string | null) => void;
}

export const handleMutationSuccess = ({
    setFieldErrors,
    setError
}: MutationSuccessHandlerParams): void => {
    setFieldErrors({});
    if (setError) setError(null);
};
